// src/router/auth.js
const authRoutes = [
  {
    path: "/",
    name: "Root",
    redirect: "/login",
  },
  {
    path: "/products",
    name: "ProductCatalog",
    component: () => import("../views/Customer/ProductCatalogView.vue"),
  },
  {
    path: "/products/:slug",
    name: "ProductDetail",
    component: () => import("../views/Customer/ProductDetailView.vue"),
  },
  {
    path: "/login",
    name: "Login",
    component: () => import("../views/auth/Login.vue"),
  },
  {
    path: "/register",
    redirect: "/login",
  },
  {
    path: "/forgot-password",
    name: "ForgotPassword",
    component: () => import("../views/auth/ForgotPassword.vue"),
  },
  {
    path: "/forgot-passward",
    redirect: "/forgot-password",
  },
  {
    path: "/reset-password",
    name: "ResetPassword",
    component: () => import("../views/auth/ResetPassword.vue"),
  },
  {
    path: "/confirm-mail",
    name: "ConfirmMail",
    component: () => import("../views/auth/ConfirmMail.vue"),
  },
  {
    path: "/lock-screen",
    name: "LockScreen",
    component: () => import("../views/auth/LockScreen.vue"),
  },
  {
    path: "/otp",
    name: "OTP",
    component: () => import("../views/auth/OTP.vue"),
  },
  {
    path: "/login-otp",
    name: "LoginOTP",
    component: () => import("../views/auth/LoginOTP.vue"),
  },
  {
    path: "/change-password",
    name: "ChangePassword",
    component: () => import("../views/auth/ChangePassword.vue"),
  },
  {
    path: "/social-callback",
    name: "SocialCallback",
    component: () => import("../views/auth/SocialCallback.vue"),
  },
  {
    path: "/error",
    name: "ErrorPage",
    component: () => import("../views/auth/ErrorPage.vue"),
  },
  {
    path: "/super-admin/login",
    name: "SuperAdminLogin",
    component: () => import("../views/SuperAdmin/SuperAdminLoginView.vue"),
  },
];

export default authRoutes;
